const VideoIcon = (props) => {
  return (
    <svg
      width="25px"
      height="25px"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Video</title>
      
      <g fill="#000000" fillRule="evenodd">
        <path
          d="M768 304.64v414.72H256V304.64h512zm-460.8 51.301v312.94h409.6V355.94H307.2z"
          fillRule="nonzero"
        />
        
        <path d="M604.086 513.28l-142.988-96v192z" />
      </g>
    </svg>
  );
};

export default VideoIcon;
